import { buildURL, request } from "@/api";

const attrs = {
  updated_at: ""
};

const getters = {
  userBySpace: state => space => {
    return space.user_permissions.map(permission => {
      const user = state.content.find(user => user.id === permission.user_id);
      return { ...user, ...permission };
    });
  }
};

const actions = {
  async resendInvite({ dispatch }, payload) {
    const type = "users";
    const id = payload.id;
    let url = buildURL({ type, id });
    return request("GET", url + "/resend")
      .then(() => {
        dispatch("snackSuccess", `Resend succesfully.`, { root: true });
      })
      .catch(() => {
        dispatch("snackError", `An error appeared.`, { root: true });
      });
  }
};

export default {
  generic: {
    attrs
  },
  actions,
  getters
};
